<template>
  <table class="table table-bordered table-sm">
    <thead class="thead-light">
    <tr>
      <th width="10%" scope="col" class="text-center">Correct answer</th>
      <th width="65%" scope="col">Answer</th>
      <th width="15%" scope="col">Order</th>
      <th width="10%" scope="col" class="text-center">Action</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(v, index) in $v.answerList.$each.$iter" :key="index">
      <td class="text-center">
        <b-form-radio v-model="selectedRightAnswer" name="radios" :value="index">Yes</b-form-radio>
      </td>
      <td>
        <b-form-input v-model="v.answer.$model" :class="{'is-invalid': v.answer.$error}" size="sm" placeholder="Answer"></b-form-input>
      </td>
      <td>
        <b-form-input v-model="v.sorder.$model" :class="{'is-invalid': v.sorder.$error}" size="sm" type="number"></b-form-input>
      </td>
      <td class="text-center">
        <b-button variant="danger" size="sm" @click="removeAnswer(v.$model)"><i class="icon-close"></i></b-button>
      </td>
    </tr>
    <tr v-if="answerList.length < 10">
      <td colspan="4" class="text-center">
        <b-button variant="success" size="sm" @click="addNewRow"><i class="icon-plus"></i> New Answer</b-button>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'AnswerTableComponent',
  data () {
    return {
      answerList: [
        {isRightAnswer: false, answer: '', sorder: 1},
        {isRightAnswer: false, answer: '', sorder: 2},
        {isRightAnswer: false, answer: '', sorder: 3},
        {isRightAnswer: false, answer: '', sorder: 4}
      ],
      selectedRightAnswer: 0
    }
  },
  methods: {
    getItems () {
      this.answerList.forEach(function (item) {
        item.isRightAnswer = false
      })
      this.answerList[this.selectedRightAnswer].isRightAnswer = true

      return this.answerList
    },
    setItems (items) {
      if (!items || !items.length) return

      const list = []
      let rightIndex = 0
      items.forEach(function (item, index) {
        list.push({
          isRightAnswer: item.isRightAnswer,
          answer: item.answer,
          sorder: item.sorder
        })
        if (item.isRightAnswer) {
          rightIndex = index
        }
      })
      this.answerList = list
      this.selectedRightAnswer = rightIndex
    },
    removeAnswer (answer) {
      if (this.answerList.length > 2) {
        const answerIndex = this.answerList.indexOf(answer)
        if (answerIndex !== -1) {
          this.answerList.splice(answerIndex, 1)
        }
      } else {
        this.$toastr.error('Minimum number of answers 2')
      }
    },
    addNewRow () {
      if (this.answerList.length >= 10) {
        this.$toastr.error('You can not add more than 10 answer')
      }
      const order = this.answerList.length + 1
      this.answerList.push({
        isRightAnswer: false,
        answer: '',
        sorder: order
      })
    },
    validate () {
      return this.$v.answerList.$invalid
    },
    touch () {
      this.$v.$touch()
    }
  },
  validations: {
    answerList: {
      required,
      $each: {
        answer: {
          required
        },
        sorder: {
          required: required,
          maxLength: maxLength(2)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AnswerTableComponent.vue